import { cn } from '~/lib/cn';
import type { VariantProps } from '~/lib/variants';
import { variants } from '~/lib/variants';

interface SpinnerProps extends VariantProps<typeof spinnerVariants> {
  className?: string;
}

const spinnerVariants = variants({
  base: 'aspect-square animate-spin rounded-full border-sm border-primary-disabled border-t-primary-default',
  variants: {
    size: {
      sm: 'w-lg border-2xs',
      md: 'w-2xl border-xs',
    },
  },
  defaultVariants: {
    size: 'md',
  },
});

function Spinner({ size, className }: SpinnerProps) {
  const spinnerClassName = spinnerVariants({ size });

  return (
    <div className={cn(spinnerClassName, className)} data-testid="spinner" />
  );
}

Spinner.displayName = 'Spinner';

export { Spinner };
